import { ModelStatus, PrometheusEditorContainer, SubspaceType} from '@tableau/predictive-model-ui';
import React from 'react';

import { BrowserTitleService } from '~src/commonInfra/services/BrowserTitleService';
import { SpaceContainerStyles } from '~src/spacesPlatform/style/SpaceContainerStyles';
export interface PredictiveModelSpaceOwnProps {
  // TODO - Props for predictive model
  // WHATEVER you add here, it needs to be passed from PredictiveModelSpaceProvider
}

export interface PredictiveModelSpaceStateProps {
  //TODO - State props for predictivemodel
}

export interface PredictiveModelSpaceDispatchProps {
    //TODO - Dispatch props for predictivemodel
  readonly requestSpaceContents: () => void;
}

export type PredictiveModelSpaceProps = PredictiveModelSpaceStateProps
  & PredictiveModelSpaceDispatchProps
  & PredictiveModelSpaceOwnProps;

//const testIdPrefix = 'predictive-model';
// const HEADER_TEST_ID = `${testIdPrefix}-header`;
// const EMPTY_STATE_TEST_ID = `${testIdPrefix}-empty-state`;

export class PredictiveModelSpace extends React.PureComponent<PredictiveModelSpaceProps> {

  public componentDidMount() {
    BrowserTitleService.setTitleWithPlaceEntityName({ placeEntityName: 'predictive model' });
    this.props.requestSpaceContents();
  }

  public render(): JSX.Element {
    return (
      <div className={SpaceContainerStyles.SpaceContainer}>
        <PrometheusEditorContainer modelStatus={ModelStatus.Undefined} subspace={SubspaceType.Connect}/>
      </div>
    );
  }
}
